import { useCookies } from "react-cookie"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Header from "../../../components/Header"
import { ReactSVG } from "react-svg"
import { useEffect, useState } from "react"
import { deleteCaseFromList, getSingleCaseData } from "../../../redux/action/cases/casesAction"
import CaseHeaderTabs from "../../../components/Cases/Case/Tabs"
import CaseContent from "../../../components/Cases/Case/Content"
import LoadingDot from "../../../components/UI/LoadingDot"
import CaseContentTitle from "../../../components/Cases/Case/Content/Title"
import { SET_ACTIVE_TAB_SINGLE_CASE, SET_LAST_OPENED_SINGLE_CASE, SET_LOADING_SINGLE_CASE } from "../../../redux/action/cases/casesType"
import { DELETE_CASE_FROM_HOME_INFO } from "../../../redux/action/home/homeType"
import { DELETE_CASE_FROM_CONTACTS, DELETE_CASE_FROM_CONTACT_INFO_CONTACTS } from "../../../redux/action/contacts/typeContacts"
import ConfirmModal from "../../../components/UI/ConfirmModal"
import ToastCustom from "../../../components/UI/ToastCustom"

const Case = () => {

    const dispatch = useDispatch()
    const deleteLoading = useSelector(state => state.cases.deleteLoading)
    const singleCaseLoading = useSelector(state => state.cases.singleCaseLoading)
    const singlesCase = useSelector(state => state.cases.singlesCase)
    const activeTab = useSelector(state => state.cases.singleCaseActiveTab)
    const lastOpenedSingleCase = useSelector(state => state.cases.singleCaseLastOpened)
    const homeInfoLoaded = useSelector(state => state.home.loaded)
    const profilesList = useSelector(state => state.contacts.profilesList)
    const contactInfo = useSelector(state => state.contacts.contactInfo)
    const loading = useSelector(state => state.cases.singleCaseLoading)
    
    const archiveLikeLoading = useSelector(state => state.cases.archiveLikeLoading)
    const errorMessageArchiveLike = useSelector(state => state.cases.errorArchiveLike)

    const [showDropdownMore, setShowDropdownMore] = useState(false)
    const [showDeleteCaseModal, setShowDeleteCaseModal] = useState(false)

    const [showTitle, setShowTitle] = useState(window.innerWidth > 393)

    const [data, setData] = useState()
    const [firstData, setFirstData] = useState()
    const [tabs] = useState(['اطلاعات', 'مدارک', 'یادداشت‌های', 'رویدادهای', 'امور‌مالی'])
    const [changes, setChanges] = useState([])

    const location = useLocation()
    const params = useParams()
    const navigate = useNavigate()

    const [cookies] = useCookies(['authToken'])

    useEffect(() => {

        selectLastOpenedSingleCase()

        if(params.id && !singlesCase[params.id])
            getInfoSingleCase()
        else {
            setData( singlesCase[params.id] )
            setFirstData( singlesCase[params.id] )
        }

        window.scrollTo({top: 0})

        return () => {
            if(document.body.classList.contains('modal-opened'))
                document.body.classList.remove('modal-opened')
            
            window.removeEventListener('resize', setCanIShowTitle)
        }

    }, [])

    useEffect(() => {

        if(params.id && singlesCase[params.id]){
            setData( {...singlesCase[params.id]} )
            setFirstData( {...singlesCase[params.id]} )
        }

    }, [ singlesCase ])

    useEffect(() => {

        if(data){
            window.addEventListener('resize', setCanIShowTitle)
            setCanIShowTitle()
        }

        return () => {
            window.removeEventListener('resize', setCanIShowTitle)
        }

    }, [data])

    const setCanIShowTitle = () => {
        setShowTitle( window.innerWidth >= 393 || Number(data?.title?.length) <= 15 )
    }

    const selectLastOpenedSingleCase = () => {
        
        if(lastOpenedSingleCase !== params.id){
            
            dispatch({
                type: SET_LAST_OPENED_SINGLE_CASE,
                payload: params.id
            })

            if(activeTab !== 0){
                
                dispatch({
                    type: SET_ACTIVE_TAB_SINGLE_CASE,
                    payload: 0
                })

            }

            window.scrollTo({top: 0})

        }

    }

    const getInfoSingleCase = async () => {

        const data = await dispatch( await getSingleCaseData(params.id, cookies.authToken) )

        if(data){
            setData( data )
            setFirstData( data )
        }

    }
    const showDeleteCaseAlert = () => {
        setShowDeleteCaseModal( true )
        setShowDropdownMore( false )
    }

    const changeActiveTab = (index) => {

        if(singleCaseLoading || index === activeTab) return

        dispatch({
            type: SET_ACTIVE_TAB_SINGLE_CASE,
            payload: index
        })

        dispatch({
            type: SET_LOADING_SINGLE_CASE,
            payload: true
        })

        setTimeout(() => {

            dispatch({
                type: SET_LOADING_SINGLE_CASE,
                payload: false
            })

        }, 200)

    }

    return (
        <>
            
            <Header 
                title={(data?.title && showTitle) ? data?.title : (!data?.title && loading) ? <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`} className="w-9 mr-3" /> : 'جزئیات پرونده'}
                backBtn={true}
                backPath={!location?.state?.home ? '/law-suits' : '/'}
            >

            </Header>
            
            <main className="main-content">

                { !showTitle &&
                    
                    <CaseContentTitle 
                        label={`${tabs[activeTab]} پرونده`}
                        title={data?.title}
                    />
                
                }

                <CaseHeaderTabs 
                    activeTab={activeTab}
                    onSetActiveTab={changeActiveTab}
                    fixedTop={showTitle}
                />

                <CaseContent 
                    activeTab={activeTab}
                    spaceTop={showTitle}
                    
                    firstData={ firstData }
                    onSetFirstData={ setFirstData }
                    
                    changes={changes}
                    onSetChanges={ setChanges }

                    data={ data }
                    onSetData={ setData }
                />

                { (deleteLoading || archiveLikeLoading) && <LoadingDot /> }

                { (errorMessageArchiveLike)  && 
                    
                    <ToastCustom>
                        
                        <div className="flex items-center gap-2">
                            <ReactSVG
                                className="text-rose-500/90 4xm:w-8 w-6"
                                src={`${process.env.PUBLIC_URL}/assets/images/icons/info-box.svg`}
                            />

                            { errorMessageArchiveLike }

                        </div>

                    </ToastCustom>

                }

            </main>

        </>
    )

}

export default Case